import {createApp} from 'vue'
import App from './App.vue'
// 插件
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import I18n from "@/lang/i18n.js"
// import Modal from '@/components/plugin/modal'

console.log('VUE_APP_API_BASE_URL', process.env.VUE_APP_API_BASE_URL);

const app = createApp(App)
// 引入插件
app.use(router)
app.use(store)
app.use(I18n);
// Modal(app)
installElementPlus(app)

app.mount('#app')
